export const truncate = (string, num) => {
    return string.length > num ? string.slice(0, num).trim() + '...' : string;
};